//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseViewObject = require('@/tbs/model/vo/BaseViewObject')
const ClassFunc = require('@/tbs/util/ClassFunc')
const DateTimeFunc = require('@/tbs/util/DateTimeFunc')
const Organization = require('@/tbs/model/to/Organization')
const organization = new Organization
/**
 * The OrganizationAuthentication class acts as the view object for the organization.
 */
const tbs_model_vo_OrganizationAuthentication = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseViewObject, arguments)
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_OrganizationAuthentication.prototype = {
    /* The view object name */
    name: 'authentication',
    /* The view object instance */
    view: {
        get: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminGetCrmAccountCertification',
            basePath: 'data.certification',
            rule: {
                id: 'accountId',
                status: '$certificationStatus',
                type: '~type',
                businessFullName: 'name',
                businessLicencePicUrl: 'license.photo',
                businessLicenceCode: 'license.number',
                businessLicenceStartDate: '$license.periodBegin',
                businessLicenceStartDateLabel: 'license.periodBegin',
                businessLicenceEndDate: '$license.periodEnd',
                businessLicenceEndDateLabel: '$license.periodEnd',
                credentialType: 'license.type',
                credentialTypeLabel: '$license.type',
                credentialFullName: 'name',
                credentialPicUrl: 'license.photo',
                credentialCode: 'license.number',
                credentialStartDate: '$license.periodBegin',
                credentialStartDateLabel: 'license.periodBegin',
                credentialEndDate: '$license.periodEnd',
                credentialEndDateLabel: '$license.periodEnd',
                credentialRegistrationAddress: 'license.registeredAddress',
                userFullName: 'name',
                userFacePhotoPicUrl: 'personCert.photoA',
                userNationalEmblemPicUrl: 'personCert.photoB',
                userIndentityCode: 'personCert.number',
                userPhone: 'mobile',
                failedMsg: 'failureMsg',
            }
        },
        create: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminCreateCrmAccountCertification',
            basePath: '',
            rule: {
                id: '#id',
                type: '#type',
                licenseType: 'credentialType',
                name: '$type,businessFullName,credentialFullName,userFullName',
                licensePhoto: '$type,businessLicencePic,businessLicencePicUrl,credentialPic,credentialPicUrl',
                licenseNumber: '$type,businessLicenceCode,credentialCode',
                licensePeriodBegin: '$type,businessLicenceStartDate,credentialStartDate',
                licensePeriodEnd: '$type,businessLicenceEndDate,credentialEndDate',
                licenseRegisteredAddress: 'credentialRegistrationAddress',
                certType: '(0)',
                certNumber: 'userIndentityCode',
                certPhotoA: 'userFacePhotoPic',
                certPhotoB: 'userNationalEmblemPic',
                mobile: 'userPhone',
            }
        },
        update: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminUpdateCrmAccountCertification',
            basePath: '',
            rule: {
                id: '#id',
                type: '#type',
                licenseType: 'credentialType',
                name: '$type,businessFullName,credentialFullName,userFullName',
                licensePhoto: '$type,businessLicencePic,businessLicencePicUrl,credentialPic,credentialPicUrl',
                licenseNumber: '$type,businessLicenceCode,credentialCode',
                licensePeriodBegin: '$type,businessLicenceStartDate,credentialStartDate',
                licensePeriodEnd: '$type,businessLicenceEndDate,credentialEndDate',
                licenseRegisteredAddress: 'credentialRegistrationAddress',
                certType: '(0)',
                certNumber: 'userIndentityCode',
                certPhotoA: '$userFacePhotoPic,userFacePhotoPicUrl',
                certPhotoB: '$userNationalEmblemPic,userNationalEmblemPicUrl',
                mobile: 'userPhone',
            }
        },
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    formatCertPhotoA: function(userFacePhotoPic, userFacePhotoPicUrl) {
        return userFacePhotoPic ? userFacePhotoPic : userFacePhotoPicUrl
    },
    formatCertPhotoB: function(userNationalEmblemPic, userNationalEmblemPicUrl) {
        return userNationalEmblemPic ? userNationalEmblemPic : userNationalEmblemPicUrl
    },
    formatLicensePeriodEnd: function(type, businessLicenceEndDate, credentialEndDate) {
        return type == '1' ? DateTimeFunc.formatDate(businessLicenceEndDate) : DateTimeFunc.formatDate(credentialEndDate)
    },
    formatLicensePeriodBegin: function(type, businessLicenceStartDate, credentialStartDate) {
        return type == '1' ? DateTimeFunc.formatDate(businessLicenceStartDate) : DateTimeFunc.formatDate(credentialStartDate)
    },
    formatLicenseNumber: function(type, businessLicenceCode, credentialCode) {
        return type == '1' ? businessLicenceCode : credentialCode
    },
    formatLicensePhoto: function(type, businessLicencePic, businessLicencePicUrl, credentialPic, credentialPicUrl) {
        console.log('formatLicensePhoto', type, businessLicencePic, businessLicencePicUrl, credentialPic, credentialPicUrl)
        return type == '1' ? (businessLicencePic ? businessLicencePic : businessLicencePicUrl) : (credentialPic ? credentialPic : credentialPicUrl)
    },
    formatName: function(type, businessFullName, credentialFullName, userFullName) {
        if (type == '1') {
            return businessFullName
        }
        else if (type == '2') {
            return credentialFullName
        }
        else {
            return userFullName
        }
    },
    renderCredentialTypeLabel: function(licenseType) {
        const options = this.getCredentialTypeOptions()
        for (let i = 0; i < options.length; i++) {
            let option = options[i]
            if (option.value == licenseType) {
                return option.label
            }
        }
    },
    renderCredentialEndDateLabel: function(credentialPeriodEnd) {
        if (this._renderEndDate(credentialPeriodEnd) === '') {
            return organization.localeProp('long-term')
        }
        else {
            return credentialPeriodEnd
        }
    },
    renderCredentialEndDate: function(credentialPeriodEnd) {
        if (credentialPeriodEnd) {
            return new Date(credentialPeriodEnd)
        }
    },
    renderCredentialStartDate: function(credentialPeriodBegin) {
        return credentialPeriodBegin ? new Date(credentialPeriodBegin) : null
    },
    renderBusinessLicenceEndDate: function(licensePeriodEnd) {
        if (licensePeriodEnd) {
            return new Date(licensePeriodEnd)
        }
    },
    renderBusinessLicenceEndDateLabel: function(licensePeriodEnd) {
        if (this._renderEndDate(licensePeriodEnd) === '') {
            return organization.localeProp('long-term')
        }
        else {
            return licensePeriodEnd
        }
    },
    renderBusinessLicenceStartDate: function(licensePeriodBegin) {
        return licensePeriodBegin ? new Date(licensePeriodBegin) : null
    },
    renderStatus: function(certificationStatus) {
        if (certificationStatus == -2) {
            return '1'
        }
        else if (certificationStatus == -1) {
            return '4'
        }
        else if (certificationStatus == 0) {
            return '2'
        }
        else if (certificationStatus == 1) {
            return '3'
        }
        else {
            return '1'
        }
    },
    getOrganizationTypeOptions: function() {
        return [
            { label: organization.localeProp('organization-type-1'), value: '1' },
            { label: organization.localeProp('organization-type-2'), value: '2' },
            { label: organization.localeProp('organization-type-3'), value: '3' },
        ]
    },
    getCredentialTypeOptions: function() {
        return [
            { label: organization.localeProp('credential-type-1'), value: 'PUBLIC_INSTITUTION' },
            { label: organization.localeProp('credential-type-2'), value: 'GOVERNMENT_OFFICE' },
            { label: organization.localeProp('credential-type-3'), value: 'SOCIAL_ORGANIZATION_01' },
            { label: organization.localeProp('credential-type-4'), value: 'SOCIAL_ORGANIZATION_02' },
            { label: organization.localeProp('credential-type-5'), value: 'SOCIAL_ORGANIZATION_03' },
        ]
    },
    getOrganizationTypeLabel: function(type) {
        return organization.localeProp('organization-type-' + type)
    }
}

//--------------------------------------------------
// extends the BaseViewObject
//--------------------------------------------------
ClassFunc.extend(tbs_model_vo_OrganizationAuthentication, BaseViewObject);

module.exports = tbs_model_vo_OrganizationAuthentication